import { number, string } from "prop-types";

const portfolio = {
  id: number,
  name: string,
};

export default portfolio;
